import { IllegalArgumentError } from 'faro-common-model';
export function toActivityScheduleRuleType(type) {
    if ([
        'fixed',
        'non-fixed-day',
        'unscheduled-visit',
        'early-termination',
        'custom-reported',
        'custom-non-reported',
        'recurring',
    ].includes(type))
        return type;
    throw new IllegalArgumentError(`Invalid activity schedule rule type [${type}]`);
}
//# sourceMappingURL=activity-schedule-rule-type.js.map